import {
  listAgents,
  listChapters,
  listClients,
  listContextUsers,
  listCycles,
  listIssueLabels,
  listIssues,
  listProducts,
  listProjects,
  listResearchTracks,
  listRoadmap,
} from "../../shared/api/client";
import { useWorkhubQuery } from "../../shared/api/hooks";

export function useIssueReferenceData(dependency?: string, enabled = true) {
  const options = { enabled };

  return {
    agents: useWorkhubQuery(listAgents, [], options),
    chapters: useWorkhubQuery(listChapters, [], options),
    clients: useWorkhubQuery(listClients, [], options),
    cycles: useWorkhubQuery(listCycles, [], options),
    issues: useWorkhubQuery(listIssues, dependency ? [dependency] : [], options),
    labels: useWorkhubQuery(listIssueLabels, [], options),
    products: useWorkhubQuery(listProducts, [], options),
    projects: useWorkhubQuery(listProjects, [], options),
    researchTracks: useWorkhubQuery(listResearchTracks, [], options),
    roadmap: useWorkhubQuery(listRoadmap, [], options),
    users: useWorkhubQuery(listContextUsers, [], options),
  };
}
